import { useState } from "react";
import { Auth } from "aws-amplify";
import { LinearProgress } from "@mui/material";
import React, { useEffect, useRef, useLayoutEffect } from "react";
import FeedbackComponent from "./FeedbackComponent";
import { Link } from "react-router-dom";
import { FaArrowAltCircleDown } from "react-icons/fa";
import ReactStars from "react-stars";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faMicrophone,
  faStopCircle,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

const TTS_API_URL =
  "https://asia-south1-sincere-kit-439505-n0.cloudfunctions.net/tts";

function BussinessNewChat() {
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [trainload, setTrainload] = useState(false);
  const [answerload, setAnswerload] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [question, setQuestion] = useState("");
  const [question1, setQuestion1] = useState("");
  const [output, setOutput] = useState("");
  const [error, setError] = useState("");
  const [feedbackResponses, setFeedbackResponses] = useState([]);
  const [deleteError, setdeleteError] = useState("");
  // const [selectedModel, setSelectedModel] = useState("meta.llama2-13b-chat-v1");
  // const [modeltext, setModelText] = useState("LLAMA 13b");
  const [userName, setUsername] = useState("");
  const timetaken = useRef(0);
  const [hasRunActivity, setHasRunActivity] = useState(false);
  const [chatbotFeedback, setChatbotFeedback] = useState([]);

  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [messages, setMessages] = useState([]);
  const [genaiaccess, setgenaiaccess] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [transcript, setTranScript] = useState("");
  const [input1, setInput1] = useState("");
  const [input2, setInput2] = useState("");
  const messagesEndRef = useRef(null);
  const [progress, setProgress] = useState(0);
  const [isStartChatStarted, setIsStartChatStarted] = useState(false);
  const [empathyScore, setEmpathyScore] = useState(0);
  const [activeObservationScore, setActiveObservationScore] = useState(0);
  const [highStakesScore, setHighStakesScore] = useState(0);
  const [varyingOpinionsScore, setVaryingOpinionsScore] = useState(0);
  const [happinessScore, setHappinessScore] = useState(0);
  const [isRenderingComplete, setIsRenderingComplete] = useState(false);
  const [openPopup, setOpenPopup] = useState(true);
  const handleClosePopup = () => setOpenPopup(false);
  const [isFinished, setIsFinished] = useState(false);
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [selectedVoice, setSelectedVoice] = useState(null);
  const [openLastPopup, setOpenLastPopup] = useState(false);
  const handleCloseLastPopup = () => setOpenLastPopup(false);
  const [handleInfoClick, setHandleInfoClick] = useState(false);
  const [resultPopupOpen, setResultPopupOpen] = useState(false);
  const [feedbackText, setFeedbackText] = useState("");
  const [formattedText, setFormattedText] = useState("");
  const [showNextContent, setShowNextContent] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);
  const [dynamicSections, setDynamicSections] = useState([]);
  const [hideInputField, setHideInputField] = useState(false);
  const [isVidoeEnded, setIsVidoeEnded] = useState(false);
  const [hideEndChatButton, setHideEndChatButton] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const audioContextRef = useRef(null);
  const processorRef = useRef(null);
  const streamRef = useRef(null);
  const audioChunksRef = useRef([]);

  const scrollContainerRef = useRef(null);
  const videoRef = useRef(null);
  const bottomRef = useRef(null);
  const latestSectionRef = useRef(null);

  const scrollToLatestSection = () => {
    if (latestSectionRef.current) {
      latestSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    // Trigger scrolling whenever dynamicSections changes
    scrollToLatestSection();
  }, [FeedbackComponent]);

  useEffect(() => {
    if (messages && videoRef.current) {
      videoRef.current.play().catch((error) => {
        console.error("Autoplay failed:", error);
      });
    }
  }, [messages]);

  useEffect(() => {
    if (feedbackText.length > 0) {
      // console.log("Original Transcript: ", transcript);
      const formattedText = formatResponse(feedbackText);
      // console.log("Formatted Response: ", formattedTranscript);
      let index = 0;
      const intervalId = setInterval(() => {
        setDisplayText((prev) => prev + setFormattedText[index]);
        index++;
        if (index === formattedText.length) {
          clearInterval(intervalId);
          setTranScript("");
          if (isRenderingComplete) {
            setIsFinished(true);
          }
        }
      }, 1);
    }
  }, [transcript]);

  const formatResponse = (response) => {
    // Replacing markdown-like headers with HTML headers
    const headers = response
      .replace(/(######\s?)(.*?)\n/g, "<h6>$2</h6>")
      .replace(/(#####\s?)(.*?)\n/g, "<h5>$2</h5>")
      .replace(/(####\s?)(.*?)\n/g, "<h4>$2</h4>")
      .replace(/(###\s?)(.*?)\n/g, "<h3>$2</h3>")
      .replace(/(##\s?)(.*?)\n/g, "<h2>$2</h2>")
      .replace(/(#\s?)(.*?)\n/g, "<h1>$2</h1>");

    // Splitting and replacing bold markers
    let responseArray = headers.split("**");
    let newResponse = "";
    for (let i = 0; i < responseArray.length; i++) {
      if (i % 2 === 0) {
        newResponse += responseArray[i];
      } else {
        newResponse += "<b>" + responseArray[i] + "</b>";
      }
    }

    // Replace asterisks and newlines for proper HTML formatting
    newResponse = newResponse.replace(/\*/g, "<br/>");
    newResponse = newResponse.replace(/\n/g, "<br/>");
    newResponse = newResponse.replace(/\\"/g, '"');

    return newResponse;
  };

  const [currentPayload, setCurrentPayload] = useState({
    conversation_history_list: [],
    response: [],
    feedback: "",
    activity_4_1st_condition: true,
    activity_4_2nd_condition: false,
    evaluation_list: [],
    satisfaction_condition: false,
    count: 0,
    users_response: "",
    status: false,
  });

  const formatBoldText = (text) => {
    return text.replace(/\*\*(.*?)\*\*/g, "<strong>$1</strong>");
  };

  const handleStart = async () => {
    setHideInputField(false);
    setIsStartChatStarted(true);
    setHideEndChatButton(false);
    console.log("Handle Start is calling");

    // Reset any previous conversation and disable input field during loading
    setMessages([]);
    setIsInputDisabled(true);
    setAnswerload(true);
    setTranScript("");
    setDisplayText("");
    setFeedbackResponses([]);
    setProgress(0);
    setHappinessScore(0);

    const username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser"
    );

    // Reset the current payload for a fresh start
    const resetPayload = {
      conversation_history_list: [],
      response: [],
      feedback: "",
      activity_4_1st_condition: true,
      activity_4_2nd_condition: false,
      evaluation_list: [],
      satisfaction_condition: false,
      count: 0,
      users_response: "",
      status: false,
    };

    setCurrentPayload(resetPayload);
    // setCurrentPayload(initialPayload);
    console.log("Initial Payload before sending:", resetPayload);

    try {
      // Send a POST request to the backend with the initial payload
      const response = await fetch(
        "https://nhgbufmml2vibocg67xvaruzhy0btebl.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(resetPayload), // Send the reset payload
        }
      );

      const data = await response.json();
      console.log("First Response data:", data);

      const chatbotMessage = Array.isArray(data.message.response)
        ? data.message.response.map((msg) => formatBoldText(msg))
        : [formatBoldText(data.message.response)];

      setMessages(chatbotMessage);
      if (chatbotMessage) {
        speak(chatbotMessage);
      }
      setCurrentPayload((prevPayload) => ({
        ...prevPayload,
        ...data.message,
      }));

      // Add new section dynamically
      setDynamicSections((prevSections) => [
        ...prevSections,
        { message: chatbotMessage, feedback: "" },
      ]);

      setAnswerload(false);
      setIsInputDisabled(false);
    } catch (error) {
      console.error("Error fetching initial message:", error);

      // Stop loading and allow retry
      setAnswerload(false);
      setIsInputDisabled(false);
    }
  };

  const handleQuestion1 = async (question) => {
    setTranScript("");
    setDisplayText("");
    setQuestion("");
    setShowFeedback(true);

    if (question.length > 0) {
      timetaken.current = 0;

      // Start timer to track time taken for the request
      let time = setInterval(() => {
        timetaken.current = parseFloat(timetaken.current) + 0.1;
      }, 100);

      setAnswerload(true);
      console.log("requesting");

      // Update the current payload with the new question and conversation list
      const updatedPayload = {
        ...currentPayload,
        conversation_history_list: [
          ...currentPayload.conversation_history_list,
          question,
        ],
        users_response: question,
      };

      console.log("Payload being sent in the second request:", updatedPayload);

      try {
        // Send the updated payload to the backend
        const response = await fetch(
          "https://nhgbufmml2vibocg67xvaruzhy0btebl.lambda-url.ap-south-1.on.aws/",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(updatedPayload),
          }
        );

        if (!response.ok) {
          throw new Error(`API request failed with status ${response.status}`);
        }

        const data = await response.json();

        console.log("Second Response Data:", data);

        setAnswerload(false);

        // Safely access message and response fields
        const chatbotMessage = Array.isArray(data?.message?.response)
          ? data.message.response
          : [data?.message?.response || "No response available"];
        const chatbotConclusion = data?.message?.feedback || "";

        setMessages(chatbotMessage);
        if (chatbotMessage) {
          speak(chatbotMessage);
        }
        setDisplayText(chatbotConclusion);

        // Extract scores using regex
        const regex = /Score:\s*(\d)/g;
        const scores = [...(chatbotConclusion.matchAll(regex) || [])].map(
          (match) => parseInt(match[1])
        );

        // const happinessRegex = /\*\*Happiness score:\*\*\s*(\d+)/;
        // const happinessMatch = chatbotConclusion.match(happinessRegex);
        // const happinessScore = happinessMatch
        //   ? parseInt(happinessMatch[1], 10)
        //   : 0;

        // console.log("Happiness Score:", happinessScore);
        // console.log("ReactStars Value:", happinessScore / 20);

        const avgScore =
          scores.reduce((sum, score) => sum + score, 0) / scores.length;
        const happinessValue = Math.min(avgScore, 5); // Ensure it's capped at 5

        setHappinessScore(happinessValue);
        setEmpathyScore(scores[0] || 0);
        setActiveObservationScore(scores[1] || 0);
        setHighStakesScore(scores[2] || 0);
        setVaryingOpinionsScore(scores[3] || 0);
        setFeedbackText(chatbotConclusion);

        // Add new section dynamically
        setDynamicSections((prevSections) => {
          const updatedSections = [...prevSections];
          const lastSection = updatedSections[updatedSections.length - 1];

          // Append user query and feedback to the last dynamic section
          if (lastSection) {
            lastSection.userMessage = question;
            lastSection.feedback = chatbotConclusion;
            lastSection.empathyScore = scores[0] || 0;
            lastSection.activeObservationScore = scores[1] || 0;
            lastSection.highStakesScore = scores[2] || 0;
            lastSection.varyingOpinionsScore = scores[3] || 0;
          }

          // Add a new section for the next cycle
          updatedSections.push({
            message: chatbotMessage,
            feedback: "",
            userMessage: "",
          });

          return updatedSections;
        });

        console.log("Extracted Scores: ", {
          happinessScore: happinessValue || 0,
          empathyScore: scores[0] || 0,
          activeObservationScore: scores[1] || 0,
          highStakesScore: scores[2] || 0,
          varyingOpinionsScore: scores[3] || 0,
        });

        const updatedFlags = {
          users_response:
            data?.message?.users_response ?? currentPayload.users_response,
          conversation_history_list:
            data?.message?.conversation_history_list ??
            currentPayload.conversation_history_list,
          activity_4_1st_condition:
            data?.message?.activity_4_1st_condition ??
            currentPayload.activity_4_1st_condition,
          activity_4_2nd_condition:
            data?.message?.activity_4_2nd_condition ??
            currentPayload.activity_4_2nd_condition,
          count: data?.message?.count ?? currentPayload.count,
          evaluation_list:
            data?.message?.evaluation_list ?? currentPayload.evaluation_list,
          satisfaction_condition:
            data?.message?.satisfaction_condition ??
            currentPayload.satisfaction_condition,
        };

        console.log(
          "Satisfaction condition:",
          data?.message?.satisfaction_condition
        );
        if (data?.message?.satisfaction_condition === true) {
          setHideInputField(true);
        }

        setCurrentPayload((prevPayload) => {
          const mergedPayload = {
            ...prevPayload,
            ...updatedFlags,
            conversation_history_list: [
              ...prevPayload.conversation_history_list,
              ...chatbotMessage,
            ],
          };
          return mergedPayload;
        });

        console.log(data?.message?.satisfaction_condition, "##########");

        if (data?.message?.satisfaction_condition) {
          setOpenLastPopup(true);
        }

        for (let i = 0; i < chatbotMessage.length; i++) {
          const msg = String(chatbotMessage[i] || "").trim();

          await new Promise((resolve) => {
            setMessages((prevMessages) => [
              ...prevMessages,
              {
                text: msg,
                direction: "incoming",
                id: Math.random().toString(),
                feedback: chatbotConclusion,
                onComplete: resolve,
              },
            ]);
          });
        }

        clearInterval(time);
        setTranScript(chatbotConclusion);

        if (chatbotConclusion.trim()) {
          setFeedbackResponses((prevFeedback) => [
            ...prevFeedback,
            {
              text: `Feedback ${prevFeedback.length + 1}`,
              conclusion: chatbotConclusion,
              id: Math.random().toString(),
            },
          ]);
        }
      } catch (error) {
        console.error("Error occurred during the request:", error);
        setAnswerload(false);

        const errorMessage = {
          id: Math.random().toString(),
          text: "Something went wrong",
          sender: "Chatbot",
          direction: "incoming",
        };
        setMessages((prevMessages) => [...prevMessages, errorMessage]);
        clearInterval(time);
      }
    } else {
      setError("Please enter a question");
    }
  };

  // Scroll to the top of the container when showNextContent is true
  useEffect(() => {
    if (showNextContent && scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }, [showNextContent]);

  const speak = async (message) => {
    if (!message) return;

    // Remove emojis from the message
    const cleanedMessage = String(message).replace(
      /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F700}-\u{1F77F}\u{1F780}-\u{1F7FF}\u{1F800}-\u{1F8FF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu,
      ""
    );

    try {
      const payload = {
        text: cleanedMessage,
        voice: "en-IN-Standard-A", // Always use female voice
      };

      const response = await fetch(TTS_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        throw new Error(`TTS error: ${response.status} ${response.statusText}`);
      }

      const json = await response.json();
      const base64Audio = json.audioContent;

      // Create the audio element and play
      const audio = new Audio(`data:audio/mp3;base64,${base64Audio}`);

      audio.play().catch((err) => {
        console.error("Audio playback failed:", err);
      });
    } catch (error) {
      console.error("Error in speak function:", error);
    }
  };

  const scrollToHeight = (height) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollTo({
        top: height,
        behavior: "smooth",
      });
    }
  };

  const scrollToBottom = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleVideoEnd = () => {
    setIsVidoeEnded(true);

    setTimeout(() => {
      if (bottomRef.current) {
        bottomRef.current.scrollIntoView({ behavior: "smooth" });
      }
    }, 0);
  };

  const handleEndConversation = async () => {
    setAnswerload(true); // Show loading while sending request
    setHideEndChatButton(true);

    const endPayload = {
      ...currentPayload,
      status: true, // Notify backend to end the conversation
    };

    console.log("Sending end conversation payload:", endPayload);

    try {
      const response = await fetch(
        "https://nhgbufmml2vibocg67xvaruzhy0btebl.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(endPayload),
        }
      );

      if (!response.ok) {
        throw new Error(`API request failed with status ${response.status}`);
      }

      const data = await response.json();
      console.log("End conversation response:", data);

      // Backend response
      const chatbotMessage =
        data?.message?.response || "The chat has been ended.";

      // **Add the final response in a new dynamic section**
      setDynamicSections((prevSections) => [
        ...prevSections,
        {
          message: chatbotMessage, // Show backend response
          feedback: "", // No additional feedback required
          userMessage: "", // No user input after ending
        },
      ]);

      // Ensure chat display box updates
      setMessages((prevMessages) => [...prevMessages, chatbotMessage]);
      setDisplayText(chatbotMessage); // Manually set the final display text
      setHideInputField(true); // Hide input field
    } catch (error) {
      console.error("Error ending conversation:", error);
      const errorMessage =
        "Something went wrong while ending the conversation.";

      // Add error message to chat
      setMessages((prevMessages) => [...prevMessages, errorMessage]);
      setDisplayText(errorMessage);

      // Add error message in a new dynamic section
      setDynamicSections((prevSections) => [
        ...prevSections,
        { message: errorMessage, feedback: "", userMessage: "" },
      ]);
    } finally {
      setAnswerload(false); // Hide loading spinner
    }
  };

  const captureAudio = () => {
    if (isRecording) return;

    navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((stream) => {
        setIsRecording(true);
        const audioContext = new AudioContext({ sampleRate: 16000 });
        audioContextRef.current = audioContext;

        const input = audioContext.createMediaStreamSource(stream);
        const processor = audioContext.createScriptProcessor(4096, 1, 1);
        processorRef.current = processor;
        streamRef.current = stream;

        input.connect(processor);
        processor.connect(audioContext.destination);

        processor.onaudioprocess = (event) => {
          const audioData = event.inputBuffer.getChannelData(0);
          audioChunksRef.current.push(new Float32Array(audioData));
          console.log("Audio chunk received:", audioData.length);
        };

        console.log("Recording started");
      })
      .catch((err) => {
        console.error("Error capturing audio:", err);
      });
  };

  const handleMicrophoneStop = () => {
    if (!isRecording) return;

    if (processorRef.current) {
      processorRef.current.disconnect();
    }
    if (audioContextRef.current) {
      audioContextRef.current.close();
    }
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop());
    }

    setIsRecording(false);
    console.log("Recording stopped");

    if (audioChunksRef.current.length === 0) {
      console.error("No audio data captured");
      return;
    }

    const totalLength = audioChunksRef.current.reduce(
      (acc, chunk) => acc + chunk.length,
      0
    );
    const fullAudioBuffer = new Float32Array(totalLength);
    let offset = 0;
    for (const chunk of audioChunksRef.current) {
      fullAudioBuffer.set(chunk, offset);
      offset += chunk.length;
    }

    console.log("Total audio length (samples):", fullAudioBuffer.length);

    audioChunksRef.current = [];

    // Send the audio buffer for transcription
    sendAudioToServer(fullAudioBuffer).then((transcriptionText) => {
      if (transcriptionText.startsWith("Error")) {
        console.error(transcriptionText);
      } else {
        // Call handleSendMessage with the transcription
        handleQuestion1(transcriptionText);
      }
    });
  };

  const sendAudioToServer = async (fullAudioBuffer) => {
    try {
      const int16Buffer = convertFloat32ToInt16(fullAudioBuffer);
      console.log("Int16 Buffer Length:", int16Buffer.length);

      const base64Audio = arrayBufferToBase64(int16Buffer.buffer);
      console.log("Base64 Audio Length:", base64Audio.length);

      const data = {
        "audio-data": base64Audio,
      };

      const response = await fetch(
        "https://2ebgwsxstddkvpgcehqjrhoflu0lerly.lambda-url.ap-south-1.on.aws/",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const jsonResponse = await response.json();
      console.log("Server Response:", jsonResponse);

      if (response.ok && jsonResponse.transcription) {
        return jsonResponse.transcription;
      } else {
        console.error("Error from server:", jsonResponse);
        return `Error processing transcription: ${
          jsonResponse.message || "Unknown error"
        }`;
      }
    } catch (error) {
      console.error("Error sending audio data:", error);
      return `Error sending audio data: ${error.message || "Unknown error"}`;
    }
  };

  const convertFloat32ToInt16 = (buffer) => {
    const int16Buffer = new Int16Array(buffer.length);
    for (let i = 0; i < buffer.length; i++) {
      let s = Math.max(-1, Math.min(1, buffer[i]));
      int16Buffer[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    return int16Buffer;
  };

  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const handleButtonClick = () => {
    if (isRecording) {
      handleMicrophoneStop();
    } else {
      captureAudio();
    }
  };

  const msg =
    "Hi Ashish Welcome to this module, this module is about having a crucial conversation where you are giving feedback to teammate manisha based on following 4 tenets Empathy, Active Observation, Check for High Stakes, Identify Varying Opinions";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#EAEAEA",
      }}
    >
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "100vh",
          backgroundImage: "url('./assets/images/home-banner.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            width: "calc(100% - 8rem)",
            height: "calc(100% - 8rem)",
            transform: "translate(-50%, -50%)",
            overflow: "hidden",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Scrollable Content */}
          <>
            <style>
              {`
          .custom-scrollbar {
            width: 100%;
            height: 100%;
            overflow-y: auto;
            padding: 2rem;
            box-sizing: border-box;
          }

          .custom-scrollbar::-webkit-scrollbar {
            width: 10px;
          }

          .custom-scrollbar::-webkit-scrollbar-track {
            background: gray;
          }

          .custom-scrollbar::-webkit-scrollbar-thumb {
            background-color: white;
            border-radius: 4px;
          }

          .custom-scrollbar::-webkit-scrollbar-thumb:hover {
            background-color: darkgray;
          }
        `}
            </style>
            {showNextContent && (
              <div
                style={{
                  // display: "flex",
                  alignItems: "center", // Vertically align items
                  position: "absolute",
                  right: "2rem",
                  margin: 0,
                  color: "white",
                }}
              >
                <h5 style={{ margin: 0, marginRight: "0.5rem" }}>
                  Overall Happiness Score
                </h5>
                <ReactStars
                  count={5}
                  size={36}
                  color2={"#ffd700"}
                  value={happinessScore}
                  edit={false}
                />
              </div>
            )}
            <style>
              {`
        @media (max-width: 768px) {
          .responsive-container {
            padding: 1rem; /* Adjust padding for smaller screens */
            max-width: 100%; /* Ensure full width */
          }
          .responsive-content {
            flex-direction: column; /* Stack items vertically */
            gap: 1rem;
          }
          .responsive-image {
            width: 100%; /* Adjust image size */
            height: auto; /* Maintain aspect ratio */
          }
          .responsive-feedback {
            width: 100%; /* Feedback section takes full width */
          }
        }

        @media (max-width: 480px) {
          .responsive-container {
            padding: 0.5rem; /* Reduce padding further */
          }
          .responsive-feedback {
            font-size: 0.9rem; /* Adjust font size */
          }
        }
      `}
            </style>

            <div className="custom-scrollbar">
              {/* Video Section */}
              <div
                style={{
                  width: "100%",
                  maxWidth: "900px",
                  textAlign: "center",
                  margin: "0 auto",
                }}
              >
                {showNextContent ? (
                  <div>
                    {dynamicSections.map((section, index) => (
                      <div
                        key={index}
                        className="responsive-container"
                        ref={
                          index === dynamicSections.length - 1
                            ? latestSectionRef
                            : null
                        }
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "100%",
                          maxWidth: "900px",
                          margin: "2rem auto",
                          gap: "2rem",
                        }}
                      >
                        {/* Video and Response */}
                        <div
                          className="responsive-content"
                          style={{
                            display: "flex",
                            width: "100%",
                            height: "220px",
                            gap: "2rem",
                          }}
                        >
                          {/* <video
                            autoPlay
                            controls
                            style={{
                              width: "25%",
                              height: "100%",
                              borderRadius: "12px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                              objectFit: "cover",
                            }}
                          >
                            <source src="https://d2s2rc72waq8pd.cloudfront.net/manisha-video2.mp4" />
                            Your browser does not support the video tag.
                          </video> */}

                          {!(
                            hideInputField &&
                            index === dynamicSections.length - 1
                          ) && (
                            <img
                              src="./assets/images/manisha-sad.jpg"
                              alt="Description of image"
                              className="responsive-image"
                              onLoad={scrollToBottom}
                              style={{
                                width: "25%",
                                height: "100%",
                                borderRadius: "12px",
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                                objectFit: "cover",
                              }}
                            />
                          )}

                          <div
                            style={{
                              width:
                                hideInputField &&
                                index === dynamicSections.length - 1
                                  ? "100%"
                                  : "75%",
                              background: "white",
                              borderRadius: "12px",
                              padding: "20px",
                              boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                              color: "#333",
                              textAlign: "left",
                              overflowY: "scroll",
                              scrollbarWidth: "none", // For Firefox
                              msOverflowStyle: "none", // For Internet Explorer
                            }}
                          >
                            <div
                              style={{
                                color: "#333333",
                                fontFamily: "'Outfit', sans-serif",
                                wordWrap: "break-word",
                                whiteSpace: "pre-wrap",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: `Manisha: ${section.message} <br /> 
                                ${
                                  section.userMessage
                                    ? `<div>User: ${section.userMessage}</div>`
                                    : ""
                                }`,
                              }}
                            ></div>
                          </div>
                        </div>

                        {/* Feedback Section */}
                        {section.feedback && (
                          <div
                            ref={
                              index === dynamicSections.length - 1
                                ? latestSectionRef
                                : null
                            }
                          >
                            <FeedbackComponent
                              empathyScore={section.empathyScore}
                              activeObservationScore={
                                section.activeObservationScore
                              }
                              highStakesScore={section.highStakesScore}
                              varyingOpinionsScore={
                                section.varyingOpinionsScore
                              }
                              feedbackText={section.feedback}
                            />
                          </div>
                        )}
                      </div>
                    ))}

                    {/* Input Field Section */}
                    <div
                      style={{
                        width: "100%",
                        maxWidth: "800px",
                        margin: "2rem auto",
                        textAlign: "center",
                      }}
                    >
                      {!hideInputField && (
                        <div style={{ position: "relative", width: "100%" }}>
                          <textarea
                            id="response"
                            placeholder="Enter your response here..."
                            rows="5"
                            value={question}
                            onChange={(e) => setQuestion(e.target.value)}
                            style={{
                              width: "100%",
                              marginTop: "0.5rem",
                              padding: "0.8rem",
                              borderRadius: "20px",
                              border: "5px solid white",
                              outline: "none",
                              fontSize: "1rem",
                              boxSizing: "border-box",
                              resize: "none",
                              backgroundColor: "rgba(0, 0, 0, 0.65)",
                              color: "white",
                            }}
                          />
                          <button
                            onClick={handleButtonClick}
                            disabled={isInputDisabled}
                            style={{
                              background: "transparent",
                              position: "absolute",
                              right: "1rem",
                              bottom: "1rem",
                              padding: "0.5rem",
                              border: "none",
                              cursor: isInputDisabled
                                ? "not-allowed"
                                : "pointer",
                              fontSize: "1rem",
                              fontFamily: "'Outfit', sans-serif",
                              color: "#121212",
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              outline: "none",
                            }}
                          >
                            <FontAwesomeIcon
                              icon={isRecording ? faStopCircle : faMicrophone}
                              // icon={faMicrophone}
                              size="lg"
                              color={isRecording ? "white" : "white"}
                            />
                          </button>
                        </div>
                      )}
                      {/* Submit Button */}
                      {answerload ? (
                        <Spinner />
                      ) : (
                        <div
                          style={{
                            textAlign: "center",
                            marginTop: "1rem",
                          }}
                        >
                          <button
                            onClick={() =>
                              hideInputField
                                ? handleStart() && setDynamicSections([])
                                : handleQuestion1(question)
                            }
                            style={{
                              padding: "0rem 2rem",
                              backgroundColor: "#FF5A5F",
                              color: "white",
                              fontSize: "1rem",
                              fontWeight: "bold",
                              borderRadius: "8px",
                              border: "none",
                              cursor: "pointer",
                              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
                            }}
                          >
                            {hideInputField ? "Restart Chat" : "Submit"}
                          </button>
                          {!hideEndChatButton && (
                            <button
                              onClick={handleEndConversation}
                              style={{
                                padding: "0rem 2rem",
                                backgroundColor: "#FF5A5F",
                                color: "white",
                                fontSize: "1rem",
                                fontWeight: "bold",
                                borderRadius: "8px",
                                border: "none",
                                cursor: "pointer",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
                                marginLeft: "1rem",
                              }}
                            >
                              End Conversation
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div>
                    <video
                      autoPlay
                      controls
                      display="none"
                      src="https://s3.ap-south-1.amazonaws.com/new.eduvance.ai.businesssim/Crucial+Conversation+Video_2.mp4"
                      onEnded={handleVideoEnd}
                      style={{
                        width: "95%",
                        borderRadius: "12px",
                        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
                      }}
                    >
                      Your browser does not support the video tag.
                    </video>
                    {!isVidoeEnded && (
                      <p
                        style={{
                          marginTop: "1rem",
                          color: "white",
                          fontSize: "1rem",
                          lineHeight: "1.5",
                        }}
                      >
                        Instructions appear when the video completes.
                        <br />
                      </p>
                    )}
                    {/* Scroll Icon */}
                    {isVidoeEnded && (
                      <div style={{ margin: "1.5rem 0" }}>
                        <FaArrowAltCircleDown size={50} color="white" />
                      </div>
                    )}
                    {isVidoeEnded && (
                      <div ref={bottomRef} style={{ textAlign: "center" }}>
                        <button
                          onClick={() => {
                            setShowNextContent(true);
                            handleStart();
                          }}
                          style={{
                            padding: "0rem 2rem",
                            backgroundColor: "#FF5A5F",
                            color: "white",
                            fontSize: "1.15rem",
                            fontWeight: "bold",
                            borderRadius: "8px",
                            border: "none",
                            cursor: "pointer",
                            boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
                          }}
                        >
                          Continue the conversation
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </>
        </div>
      </div>
    </div>
  );
}

export default BussinessNewChat;

const Spinner = () => (
  <div style={{ display: "flex", justifyContent: "center", margin: "2rem 0" }}>
    <div
      style={{
        border: "4px solid rgba(0, 0, 0, 0.2)",
        borderTop: "4px solid #FF5A5F",
        borderRadius: "50%",
        width: "40px",
        height: "40px",
        animation: "spin 1s linear infinite",
      }}
    ></div>
    <style>
      {`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
  </div>
);
